// Phase 1 mock data — Pipeline, Contacts, Notes, Tasks, Revenue.
// NO real data. NO DB writes. NO Stripe.

export const PIPELINE_STAGES = [
  { key: "lead", label: "Lead", tone: "slate" },
  { key: "contacted", label: "Contacted", tone: "sky" },
  { key: "demo_scheduled", label: "Demo Scheduled", tone: "violet" },
  { key: "trial", label: "Trial", tone: "amber" },
  { key: "proposal_sent", label: "Proposal Sent", tone: "indigo" },
  { key: "negotiation", label: "Negotiation", tone: "fuchsia" },
  { key: "won", label: "Won", tone: "emerald" },
  { key: "lost", label: "Lost", tone: "rose" },
];

export const PROSPECTS = [
  // Won (these mirror existing clients)
  { id: "p_uncle_g", name: "Uncle Giuseppe's Marketplace", stage: "won", value: 35280, stores: 7, contact: "Anna DiLeo", region: "Long Island, NY", source: "Founder referral", lastTouch: "2 hours ago", linkedClientId: "co_uncle_giuseppe" },
  { id: "p_example", name: "Example Market", stage: "trial", value: 7680, stores: 2, contact: "Drew Whitman", region: "Austin, TX", source: "Inbound — website", lastTouch: "27 min ago", linkedClientId: "co_example_market" },
  { id: "p_demo", name: "Demo Grocery", stage: "lead", value: 0, stores: 1, contact: "Demo Admin", region: "Brooklyn, NY", source: "Sales sandbox", lastTouch: "Yesterday", linkedClientId: "co_demo_grocery" },

  // Lead
  { id: "p_coastline", name: "Coastline Provisions", stage: "lead", value: 18000, stores: 4, contact: "Mira Okafor", region: "Portland, ME", source: "NRF 2026 booth", lastTouch: "3 days ago" },
  { id: "p_brightleaf", name: "Brightleaf Co-op", stage: "lead", value: 9600, stores: 2, contact: "Sara Whittaker", region: "Burlington, VT", source: "Inbound — website", lastTouch: "6 days ago" },

  // Contacted
  { id: "p_harborfresh", name: "Harbor Fresh Foods", stage: "contacted", value: 24000, stores: 5, contact: "Luis Mendez", region: "Providence, RI", source: "Cold outbound", lastTouch: "Yesterday" },
  { id: "p_canopy", name: "Canopy Naturals", stage: "contacted", value: 14400, stores: 3, contact: "Ines Bauer", region: "Asheville, NC", source: "Partner — Square", lastTouch: "4 days ago" },

  // Demo Scheduled
  { id: "p_grovers", name: "Grover's Hometown Markets", stage: "demo_scheduled", value: 21600, stores: 4, contact: "Eli Park", region: "Raleigh, NC", source: "Inbound — website", lastTouch: "Demo Feb 11" },
  { id: "p_meridian", name: "Meridian Market", stage: "demo_scheduled", value: 8400, stores: 2, contact: "Talia Brooks", region: "Boise, ID", source: "Founder referral", lastTouch: "Demo Feb 14" },

  // Proposal Sent
  { id: "p_fieldsupply", name: "Field & Supply Grocer", stage: "proposal_sent", value: 31200, stores: 6, contact: "Otis Rowe", region: "Madison, WI", source: "Investor intro", lastTouch: "Proposal sent Feb 3" },

  // Negotiation
  { id: "p_ferncreek", name: "Fern Creek Markets", stage: "negotiation", value: 28800, stores: 5, contact: "Joaquin Reyes", region: "Eugene, OR", source: "Inbound — referral", lastTouch: "Counter received Feb 5" },

  // Lost
  { id: "p_summitfoods", name: "Summit Foods", stage: "lost", value: 19200, stores: 4, contact: "Renee Vogel", region: "Denver, CO", source: "Cold outbound", lastTouch: "Lost — chose competitor" },
  { id: "p_tworivers", name: "Two Rivers Grocers", stage: "lost", value: 12000, stores: 3, contact: "Marcus Tay", region: "Pittsburgh, PA", source: "Inbound — website", lastTouch: "Lost — timing" },
];

// Contacts keyed by client/prospect id
export const CONTACTS = {
  co_uncle_giuseppe: [
    { role: "Primary Contact", name: "Anna DiLeo", title: "VP of Operations", email: "anna.dileo@unclegs.com", phone: "+1 (631) 555-0142" },
    { role: "Secondary Contact", name: "Marco Russo", title: "Director of IT", email: "marco.russo@unclegs.com", phone: "+1 (631) 555-0186" },
  ],
  co_example_market: [
    { role: "Primary Contact", name: "Drew Whitman", title: "Owner", email: "drew@examplemarket.com", phone: "+1 (512) 555-0119" },
    { role: "Secondary Contact", name: "Tasha Ng", title: "Store Manager — Mueller", email: "tasha@examplemarket.com", phone: "+1 (512) 555-0207" },
  ],
  co_demo_grocery: [
    { role: "Primary Contact", name: "Demo Admin", title: "Sandbox Owner", email: "admin@demogrocery.test", phone: "+1 (000) 000-0000" },
  ],
  p_coastline: [
    { role: "Primary Contact", name: "Mira Okafor", title: "Director of Merchandising", email: "mira@coastlineprov.com", phone: "+1 (207) 555-0163" },
    { role: "Secondary Contact", name: "Brent Halloran", title: "Owner", email: "brent@coastlineprov.com", phone: "+1 (207) 555-0148" },
  ],
  p_harborfresh: [
    { role: "Primary Contact", name: "Luis Mendez", title: "COO", email: "luis@harborfreshfoods.com", phone: "+1 (401) 555-0192" },
  ],
  p_grovers: [
    { role: "Primary Contact", name: "Eli Park", title: "VP Operations", email: "eli.park@groversmarkets.com", phone: "+1 (919) 555-0173" },
    { role: "Secondary Contact", name: "Hannah Pugh", title: "IT Lead", email: "hannah@groversmarkets.com", phone: "+1 (919) 555-0224" },
  ],
  p_fieldsupply: [
    { role: "Primary Contact", name: "Otis Rowe", title: "President", email: "otis@fieldsupply.coop", phone: "+1 (608) 555-0115" },
  ],
  p_ferncreek: [
    { role: "Primary Contact", name: "Joaquin Reyes", title: "Director of Operations", email: "joaquin@ferncreekmarkets.com", phone: "+1 (541) 555-0167" },
    { role: "Secondary Contact", name: "Camille Doss", title: "CFO", email: "camille@ferncreekmarkets.com", phone: "+1 (541) 555-0188" },
  ],
};

export const NOTES = {
  co_uncle_giuseppe: [
    { id: "n1", author: "Rafael Soto", date: "2026-02-04", title: "Chain-wide rollout greenlit", body: "Anna confirmed all 7 stores will move to ShelfLife by end of Q1. Morris Plains and North Caldwell scheduled to onboard next week. Marco wants to set up SSO via Azure AD — flag for engineering scoping.", tags: ["rollout", "win"] },
    { id: "n2", author: "Rafael Soto", date: "2026-01-22", title: "Pilot results", body: "Smithtown, Port Washington, and East Meadow have been on ShelfLife for ~10 weeks. Shrink down 11% vs same period last year. Anna will share the case study draft for our marketing team.", tags: ["case-study", "metrics"] },
    { id: "n3", author: "Rafael Soto", date: "2025-11-04", title: "Initial signing", body: "First paying pilot. Growth plan signed. Anna is our champion. Marco is the technical decision-maker. Watch for catalog hygiene questions — they have ~18k SKUs.", tags: ["kickoff"] },
  ],
  co_example_market: [
    { id: "n4", author: "Rafael Soto", date: "2026-02-05", title: "Catalog needs operator review", body: "POS export had a MISC department with 132 rows. Drew wants to keep them grouped under Grocery but tagged for follow-up. Awaiting his sign-off before publishing the catalog.", tags: ["catalog", "blocker"] },
    { id: "n5", author: "Rafael Soto", date: "2026-01-10", title: "Trial kickoff", body: "Drew + Tasha walked through onboarding. They're impressed by the labeling workflow and the cost-per-pound calculator. Targeting full activation by end of trial (Apr 28).", tags: ["trial"] },
  ],
  co_demo_grocery: [
    { id: "n6", author: "Rafael Soto", date: "2026-01-11", title: "Sandbox provisioned", body: "Created for live sales demos. Reset weekly. Do not invite real users.", tags: ["sandbox"] },
  ],
  p_coastline: [
    { id: "n7", author: "Rafael Soto", date: "2026-01-30", title: "Met at NRF 2026", body: "Brent stopped by the booth. Currently using a legacy ERP — pain points around shrink and date-coding compliance. Mira will own the eval. Sending intro deck this week.", tags: ["nrf", "intro"] },
  ],
  p_grovers: [
    { id: "n8", author: "Rafael Soto", date: "2026-02-02", title: "Discovery call complete", body: "4 stores, ~8k SKUs, currently spreadsheet-driven for labeling. Eli is bought-in. Hannah will need a security questionnaire — pull our SOC 2 packet.", tags: ["discovery", "security"] },
  ],
  p_fieldsupply: [
    { id: "n9", author: "Rafael Soto", date: "2026-02-03", title: "Proposal sent", body: "Growth plan, 6 stores, 12-month term, custom onboarding included. Otis flagged budget approval at the board meeting Feb 18.", tags: ["proposal"] },
  ],
  p_ferncreek: [
    { id: "n10", author: "Rafael Soto", date: "2026-02-05", title: "Counter received", body: "Camille came back with a request to defer first payment 30 days. Will run by finance — likely OK given annual term and deposit on signing.", tags: ["negotiation", "finance"] },
  ],
};

export const TASKS = [
  { id: "t1", title: "Send SOC 2 packet to Grover's Hometown Markets", owner: "Rafael Soto", target: "Grover's Hometown Markets", targetId: "p_grovers", due: "2026-02-09", status: "open", priority: "high" },
  { id: "t2", title: "Approve catalog MISC department for Example Market", owner: "Rafael Soto", target: "Example Market", targetId: "co_example_market", due: "2026-02-07", status: "open", priority: "high" },
  { id: "t3", title: "Schedule Morris Plains & North Caldwell store onboarding", owner: "Rafael Soto", target: "Uncle Giuseppe's Marketplace", targetId: "co_uncle_giuseppe", due: "2026-02-10", status: "in_progress", priority: "medium" },
  { id: "t4", title: "Run finance review on Fern Creek deferred payment", owner: "Rafael Soto", target: "Fern Creek Markets", targetId: "p_ferncreek", due: "2026-02-08", status: "open", priority: "high" },
  { id: "t5", title: "Send intro deck to Coastline Provisions", owner: "Rafael Soto", target: "Coastline Provisions", targetId: "p_coastline", due: "2026-02-06", status: "open", priority: "medium" },
  { id: "t6", title: "Confirm demo agenda — Grover's Hometown Markets", owner: "Rafael Soto", target: "Grover's Hometown Markets", targetId: "p_grovers", due: "2026-02-10", status: "open", priority: "medium" },
  { id: "t7", title: "Follow up on Field & Supply board approval", owner: "Rafael Soto", target: "Field & Supply Grocer", targetId: "p_fieldsupply", due: "2026-02-18", status: "open", priority: "medium" },
  { id: "t8", title: "Draft Uncle Giuseppe's case study with Anna", owner: "Rafael Soto", target: "Uncle Giuseppe's Marketplace", targetId: "co_uncle_giuseppe", due: "2026-02-21", status: "open", priority: "low" },
  { id: "t9", title: "Renewal outreach — Uncle Giuseppe's (90 days)", owner: "Rafael Soto", target: "Uncle Giuseppe's Marketplace", targetId: "co_uncle_giuseppe", due: "2026-01-15", status: "done", priority: "medium" },
  { id: "t10", title: "Q1 pipeline review with Blue Harbor team", owner: "Rafael Soto", target: "Internal", due: "2026-02-12", status: "open", priority: "low" },
];

export const TASK_STATUS_META = {
  open: { label: "Open", tone: "slate" },
  in_progress: { label: "In progress", tone: "sky" },
  done: { label: "Done", tone: "emerald" },
  blocked: { label: "Blocked", tone: "rose" },
};

export const TASK_PRIORITY_META = {
  high: { label: "High", tone: "rose" },
  medium: { label: "Medium", tone: "amber" },
  low: { label: "Low", tone: "slate" },
};

// Revenue dashboard
export const REVENUE = {
  prospects: { count: 9, trend: "+3 this month" },
  trials: { count: 2, trend: "Example Market, Demo Grocery" },
  activeCustomers: { count: 1, trend: "Uncle Giuseppe's Marketplace" },
  mrr: { value: 2940, trend: "+$0 vs last month" },
  arr: { value: 35280, trend: "+$35.3k vs 12mo ago" },
  renewalsDue: { count: 1, trend: "Next: Uncle Giuseppe's (Apr 15)" },
  // last 6 months MRR (mocked)
  mrrHistory: [
    { month: "Sep '25", value: 0 },
    { month: "Oct '25", value: 0 },
    { month: "Nov '25", value: 2940 },
    { month: "Dec '25", value: 2940 },
    { month: "Jan '26", value: 2940 },
    { month: "Feb '26", value: 2940 },
  ],
  pipelineByStage: [
    { stage: "lead", count: 3, value: 27600 },
    { stage: "contacted", count: 2, value: 38400 },
    { stage: "demo_scheduled", count: 2, value: 30000 },
    { stage: "trial", count: 1, value: 7680 },
    { stage: "proposal_sent", count: 1, value: 31200 },
    { stage: "negotiation", count: 1, value: 28800 },
  ],
  weightedPipeline: 64880, // mock weighted projection
};

// Wizard step definitions
export const WIZARD_STEPS = [
  { key: "company", label: "Create Company" },
  { key: "stores", label: "Add Stores" },
  { key: "departments", label: "Add Departments" },
  { key: "contacts", label: "Add Contacts" },
  { key: "catalog", label: "Import Catalog" },
  { key: "users", label: "Create Users" },
  { key: "review", label: "Review" },
  { key: "activate", label: "Activate" },
];

// Department presets the wizard suggests
export const DEPARTMENT_PRESETS = [
  "Produce", "Bakery", "Deli", "Meat", "Seafood", "Dairy",
  "Frozen", "Grocery", "Prepared Foods", "Cheese",
  "Wine & Beer", "Beverages", "Floral", "Catering",
  "Health & Wellness", "Front End",
];
